import { createSvgIcon } from '../../createSvgIcon';

export const DropdownIcon = createSvgIcon(
  <path
    d="M18.1818 0C19.186 0 20 0.895455 20 2.00002V10C20 11.1046 19.186 12 18.1818 12H1.81819C0.814032 12 0 11.1046 0 10V2.00002C0 0.895455 0.814032 0 1.81819 0H18.1818ZM18 2.00002H1.99997V10H18V2.00002ZM15.6465 4.64644L16.3536 5.35355L14 7.70711L11.6464 5.35355L12.3535 4.64644L14 6.29303L15.6465 4.64644Z"
    fill="currentColor"
  />,
  { displayName: 'DropdownIcon', viewBox: '0 0 20 12' }
);
